import { render, staticRenderFns } from "./Infraestructuras.vue?vue&type=template&id=327e62e2&scoped=true"
import script from "./Infraestructuras.vue?vue&type=script&lang=js"
export * from "./Infraestructuras.vue?vue&type=script&lang=js"
import style0 from "./Infraestructuras.vue?vue&type=style&index=0&id=327e62e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e62e2",
  null
  
)

export default component.exports